module.exports = __webpack_public_path__ + "static/media/points10_10.483c4061.png";